module.exports = __webpack_public_path__ + "img/484bd50.jpg";